module.exports = __webpack_public_path__ + "img/6910dc058a59610fe88bd8562273373e.svg";